var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
module.exports = x({ ["useAppConfig"]: () => (__WEBPACK_EXTERNAL_MODULE__edreamsodigeo_frontend_app_config_1f021e6c__.useAppConfig) });